<template>
    <Head title="Log in" />

    <jet-authentication-card class="bg-minplan-blue" :style="branding?.navbar_color ? { backgroundColor: branding.navbar_color } : {}">
        <template #logo>
            <img v-if="branding?.logo_url" class="h-16 w-auto" :src="branding.logo_url" alt="immivo" />
            <img v-else class="h-16 w-auto" src="../../../image/immivo.svg" alt="immivo" />
        </template>

        <jet-validation-errors class="mb-4" />

        <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
            {{ status }}
        </div>

        <!--        <form @submit.prevent="magic" v-if="magicLink && !linkSent">-->
        <!--            <div>-->
        <!--                <jet-label for="email" :value="$t('auth.email')" />-->
        <!--                <jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus />-->
        <!--            </div>-->

        <!--            <div class="flex items-center justify-end mt-4">-->
        <!--                <primary-button class="ml-4" :class="{ 'opacity-25': form.processing }"-->
        <!--                            :disabled="form.processing">-->
        <!--                    {{ $t("auth.requestLink") }}-->
        <!--                </primary-button>-->
        <!--            </div>-->
        <!--        </form>-->

        <form @submit.prevent="login" v-if="!magicLink && !linkSent">
            <div>
                <jet-label for="email" :value="$t('auth.email')" />
                <jet-input
                    id="email"
                    type="email"
                    class="mt-1 block w-full"
                    v-model="form.email"
                    required
                    autofocus
                />
            </div>

            <div class="mt-4">
                <jet-label for="password" :value="$t('auth.password')" />
                <jet-input
                    id="password"
                    type="password"
                    class="mt-1 block w-full"
                    v-model="form.password"
                    required
                    autocomplete="current-password"
                />
            </div>

            <div class="block mt-4">
                <label class="flex items-center">
                    <jet-checkbox name="remember" v-model:checked="form.remember" />
                    <span class="ml-2 text-sm text-gray-600">{{
                        $t("auth.remember")
                    }}</span>
                </label>
            </div>

            <div class="flex items-center justify-end mt-4">
                <Link
                    :href="route('password.request')"
                    class="underline text-sm text-gray-600 hover:text-gray-900"
                >
                    {{ $t("auth.forgot") }}
                </Link>

                <primary-button
                    class="ml-4"
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                >
                    {{ $t("auth.login") }}
                </primary-button>
            </div>
        </form>

        <div v-if="linkSent">
            {{ $t("auth.linkSent") }}
        </div>

        <!--        <template #loginlink>-->
        <!--            <div>-->
        <!--                <span class="cursor-pointer" v-if="!magicLink && !linkSent" @click="magicLink = !magicLink"> {{ $t("auth.magicLinkLogin") }} </span>-->
        <!--                <span class="cursor-pointer" v-if="magicLink && !linkSent" @click="magicLink = !magicLink"> {{ $t("auth.classicLogin") }} </span>-->
        <!--            </div>-->
        <!--        </template>-->
    </jet-authentication-card>
</template>

<script>
import { defineComponent } from "vue";
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard.vue";
import JetAuthenticationCardLogo from "@/Jetstream/AuthenticationCardLogo.vue";
import PrimaryButton from "@/Jetstream/PrimaryButton.vue";
import JetInput from "@/Jetstream/Input.vue";
import JetCheckbox from "@/Jetstream/Checkbox.vue";
import JetLabel from "@/Jetstream/Label.vue";
import JetValidationErrors from "@/Jetstream/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import axios from "axios";

export default defineComponent({
    components: {
        Head,
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
        PrimaryButton,
        JetInput,
        JetCheckbox,
        JetLabel,
        JetValidationErrors,
        Link,
    },

    props: {
        canResetPassword: Boolean,
        status: String,
        branding: Object
    },

    data() {
        return {
            form: this.$inertia.form({
                email: "",
                password: "",
                remember: false,
            }),
            magicLink: false,
            linkSent: false,
        };
    },

    methods: {
        login() {
            this.form
                .transform((data) => ({
                    ...data,
                    remember: this.form.remember ? "on" : "",
                }))
                .post(this.route("login"), {
                    onFinish: () => this.form.reset("password"),
                });
        },
        // magic() {
        //     axios({
        //         url: this.route("auth.request-link"),
        //         method: "POST",
        //         data: {
        //             email: this.form.email
        //         }
        //     }).then((response) => {
        //         this.form.reset("password");
        //         this.linkSent = true;
        //     });
        // }
    },
});
</script>
